<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_BatchModify')"
    :width="$selectByLang('450px', '450px', '740px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('90px', '90px', '130px')" label-position="left">
      <el-form-item :label="$t('SystemMaintenance.DataItem')">
        <el-select v-model="dataType">
          <el-option v-for="(item, index) in dataTypeList" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="dataType === 0" :label="$t('CargoMsg.Cargo_Superior')">
        <cargo-advance-select
          :select-type="selectTypeNames.basic_data_User"
          :callback-params="{key:'manager'}"
          callback-method-type="value"
          :placeholder="' '"
          :default-value="manager?manager:''"
          :method-params="{active: true}"
          filterable
          @parentCallBack="p => {manager = p.value || 0}"
        />
      </el-form-item>
      <el-form-item v-if="dataType === 1" :label="$t('CargoMsg.Cargo_UserCompany')">
        <cargo-advance-select
          :select-type="selectTypeNames.basic_data_Office"
          :callback-params="{key:'defaultOfficeId'}"
          callback-method-type="value"
          :default-value="defaultOfficeId?defaultOfficeId:''"
          filterable
          :placeholder="' '"
          @parentCallBack="officeChanged"
        />
      </el-form-item>
      <el-form-item v-if="dataType === 1" :label="$t('CargoMsg.Cargo_UserDepartment')">
        <cargo-department-select
          :callback-params="{key:'defaultDepId'}"
          :office-id="Number(defaultOfficeId)"
          :enables="true"
          :disabled="!defaultOfficeId"
          :placeholder="' '"
          :department-id="Number(defaultDepId)"
          @change="p => {defaultDepId = p.value || 0}"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { batchUpdateUser } from '@/api/user'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { syncSpecificBasicData } from '@/utils/basicDataCache'

export default {
  name: 'BatchModifyUserDialog',
  components: { cargoAdvanceSelect, cargoUserSelect, cargoDepartmentSelect },
  props: {
    visible: { type: Boolean, required: true },
    user: { type: Object, default: null },
    userKeys: { type: Array, default: () => [] }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      hasUpdate: false,
      dataType: 0,
      dataTypeList: [
        { label: this.$t('CargoMsg.Cargo_Superior'), value: 0 },
        { label: this.$t('CargoMsg.Cargo_OfficeAndDep'), value: 1 }
      ],
      manager: 0,
      defaultOfficeId: 0,
      defaultDepId: 0
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.initData()
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        if (this.hasUpdate) {
          this.$emit('callback')
        }
      }
    }
  },
  methods: {
    initData() {
      this.hasUpdate = false
      this.dataType = 0
      this.manager = 0
      this.defaultOfficeId = 0
      this.defaultDepId = 0
    },
    officeChanged(data) {
      this.defaultOfficeId = data.value || 0
      this.defaultDepId = 0
    },
    async confirmHandler() {
      const params = {}
      params.dataType = this.dataType
      params.manager = this.manager
      params.defaultOfficeId = this.defaultOfficeId
      params.defaultDepId = this.defaultDepId
      params.uuidList = this.userKeys
      const invalid = (this.dataType === 0 && !this.manager) || (this.dataType === 1 && !this.defaultOfficeId && !this.defaultDepId)
      if (invalid) {
        this.$message.warning(this.$t('SeaExport.hasOneAtleast'))
        return
      }
      let continueSave = true
      await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmBatchModifyUser', [this.getConfirmLabel()]), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        continueSave = true
      }).catch(() => {
        continueSave = false
      })
      if (continueSave) {
        const loading = getLoading4Cxt(this)
        await batchUpdateUser(params).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('CargoMsg.Cargo_BatchModifyUserSucceed', [this.userKeys.length, this.getConfirmLabel(), this.getModifyDataLabel()]))
            syncSpecificBasicData(TYPE_NAMES.basic_data_User)
          } else {
            this.$message.error(this.$t('Message.ModificationFailed'))
          }
        }).finally(() => {
          loading.close()
        })
      }
      this.hasUpdate = true
      this.innerVisible = false
    },
    getConfirmLabel() {
      return this.dataTypeList.find(item => item.value === this.dataType).label
    },
    getModifyDataLabel() {
      let label = ''
      if (this.dataType === 0) {
        // 上级主管
        label = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.manager, 'chineseName')
      } else if (this.dataType === 1) {
        // 所属分公司/部门
        label = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', this.defaultOfficeId, 'chineseName') + '/' + ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', this.defaultDepId, 'chineseName')
      }
      return label
    }
  }
}
</script>

<style scoped lang="scss">
</style>
